import React from 'react';
import { useParams, useOutletContext } from 'react-router-dom';
import { PageHeader, SectionCard, StatusPill, EmptyState, ProjectTabBar } from '@/components/portal/PortalUI';
import { Button } from '@shared/components/ui/button';
import { Upload, FileText } from 'lucide-react';
import { supabase } from '@shared/supabaseClient';

const PortalProjectDocuments = () => {
  const { projectId } = useParams();
  const { session } = useOutletContext();
  const [isProjectLead, setIsProjectLead] = React.useState(false);

  React.useEffect(() => {
    if (!projectId) return;
    supabase.from('projects').select('project_lead_email').eq('id', projectId).single()
      .then(({ data }) => {
        if (data) setIsProjectLead(data.project_lead_email?.toLowerCase() === session?.person?.email?.toLowerCase());
      });
  }, [projectId, session]);

  const documents = [];

  return (
    <div className="space-y-6">
      <ProjectTabBar projectId={projectId} isProjectLead={isProjectLead} />
      <PageHeader
        title="Project documents"
        subtitle={`Upload RAMS and supporting documents for project ${projectId}.`}
        actions={<Button size="sm">Upload document</Button>}
      />

      <SectionCard title="Upload centre" subtitle="Keep files under the project scope">
        <div className="flex flex-col items-center justify-center gap-3 rounded-xl border border-dashed border-border bg-muted/40 px-6 py-10 text-center">
          <Upload className="h-8 w-8 text-muted-foreground" />
          <p className="text-sm font-medium text-foreground">Drop RAMS or method statements here</p>
          <p className="text-xs text-muted-foreground">Max 20MB per document. PDFs recommended.</p>
          <Button variant="outline" size="sm">Browse files</Button>
        </div>
      </SectionCard>

      {documents.length ? (
        <SectionCard title="Uploaded documents">
          <div className="space-y-3">
            {documents.map((doc) => (
              <div key={doc.id} className="flex items-center justify-between rounded-lg border border-border/60 bg-muted/40 p-4">
                <div className="flex items-center gap-3">
                  <FileText className="h-5 w-5 text-primary" />
                  <div>
                    <p className="text-sm font-semibold text-foreground">{doc.name}</p>
                    <p className="text-xs text-muted-foreground">Version {doc.version}</p>
                  </div>
                </div>
                <StatusPill tone="warning" label={doc.status} />
              </div>
            ))}
          </div>
        </SectionCard>
      ) : (
        <EmptyState
          icon={FileText}
          title="No documents yet"
          description="Uploaded RAMS packs will appear here for review."
        />
      )}
    </div>
  );
};

export default PortalProjectDocuments;
